/**
 * Recipe embeddings for the search recipes functionality
 *
 * This file contains structured recipe data that will be embedded and searchable.
 * Each recipe includes:
 * - id: Unique identifier matching the recipe name
 * - description: Embedding-optimized description of what the recipe accomplishes
 * - fullInstructions: Complete recipe text for context and execution
 * - toolsAtom: Reference to the tools atom associated with this recipe
 * - keywords: Additional searchable terms for better discovery
 */

import { recipeDefinitionsFull } from "./recipe_definitions_full";

/**
 * Get all recipe IDs for validation
 */
export function getAllRecipeIds(): string[] {
  return recipes.map((recipe) => recipe.id);
}

/**
 * Get recipes - always returns V2
 */
export function getRecipes(): typeof recipes {
  return recipeDefinitionsFull;
}

export const recipes = recipeDefinitionsFull;
